import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiVisa, BasicApiResponseModel, Core2Config } from './../../shared';
import { UniboxConfirmDtoModel, UniboxResponseContainerModel } from './unibox-response.model';

@Injectable()
export class UniboxService {

  protected readonly endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX;

  constructor(protected readonly http: HttpClient) {}

  public inquiry(refNo: string, { api_domain_url, tenantCode }: ApiVisa): Observable<any> {
    return this.http.post(`${ api_domain_url + this.endpoint_path }inquiry-by-refno/${ tenantCode }`,{ refNo });
  }

  public confirmPayment(data: UniboxConfirmDtoModel, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<BasicApiResponseModel<UniboxResponseContainerModel>> {
    return this.http.post<BasicApiResponseModel<UniboxResponseContainerModel>>(`${ api_domain_url + this.endpoint_path }unipin-credit/confirm-pay/${ tenantCode }`, data, { headers: new HttpHeaders({ authorization: jwt_secret, tenantCode }) });
  }
}
